import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Bowser from 'bowser';
import moment from 'moment';
import {
  getString,
  stringToDateShortLeadingZero,
} from '../../helpers/stringHelpers.js';
import { getLoadedStatus } from '../../helpers/loaderHelpers';
import withLoader from '../../components/Loader/withLoader.js';

import LettersLayout from './LettersLayout.js';
import Logo from './logo.png';
import LetterHead from './letterhead.png';
import HelpCard from '../../components/HelpCard/HelpCard.js';
import MessageCard from '../../components/MessagesSection/MessageCard/MessageCard.js';
import MessageCardSimple from '../../components/MessageCard/MessageCard.js';
import ReplaceContact from '../../components/Replace/ReplaceContact/ReplaceContact';
import DownloadLink from '../../components/DownloadLink/DownloadLink.js';
import LoaderProgress from '../../components/Loader/LoaderProgress/LoaderProgress.js';
import LettersIcon from '@material-ui/icons/DescriptionOutlined';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import LettersTable from './LettersTable/LettersTable';

// Actions
import { actions as routingActions } from '../../ducks/routing.js';
import { actions as authActions } from '../../ducks/auth.js';
import { actions as appActions } from '../../ducks/app.js';
import { actions as customerActions } from '../../ducks/customer.js';

import analyticsApi from '../../api/analytics.js';
import customerApi from '../../api/customer.js';
import preferencesApi from '../../api/preferences.js';

const stringsComponent = 'letters';

class Letters extends React.Component {
  state = {
    loadingLetter: false,
  };

  constructor(props) {
    super(props);
    this.downloadLetter = this.downloadLetter.bind(this);
    this.setViewedLetter = this.setViewedLetter.bind(this);
    this.isLetterViewed = this.isLetterViewed.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    // Only rerender if not in a unloaded status.
    if (getLoadedStatus(this.getLoadedStatuses(nextProps)) !== 'UNLOADED') {
      return true;
    }
    return false;
  }

  getLoadedStatuses(props = this.props) {
    const { tenancy, letters, preferences } = props;
    return [tenancy.loaded, letters.loaded, preferences.loaded];
  }

  componentDidMount() {
    const { setAppBarTitle, onLoadComplete } = this.props;

    setAppBarTitle(getString(stringsComponent, 'TITLE'));
    onLoadComplete();
  }

  downloadLetter(id) {
    const { tenancy } = this.props;
    const tenancyRef = tenancy.data.currentTenancy.tenancyRef;

    this.setState({
      loadingLetter: true,
    });
    // Download letter data (letter is in RTF format).
    customerApi
      .getLetter(tenancyRef, id)
      .then((response) => {
        // Once RTF downloaded, load the rtf.js library and convert the RTF
        // to HTML.
        import(/* webpackChunkName: "RTFJS" */ 'rtf.js').then((module) => {
          const RTFJS = module.RTFJS;
          RTFJS.loggingEnabled(false);

          let rtf = response.data.letter;

          // This is trick to make endash & emdash characters (– & —) render in the PDF
          // __endash__ & __emdash__ are placeholder strings that will later be replaced by an actual endash/emdash character
          rtf = rtf
            .replace(/\\endash/g, '__endash__')
            .replace(/\\emdash/g, '__emdash__');

          const buffer = new ArrayBuffer(rtf.length);
          const bufferView = new Uint8Array(buffer);
          for (let i = 0; i < rtf.length; i++) {
            bufferView[i] = rtf.charCodeAt(i);
          }
          const doc = new RTFJS.Document(buffer);

          let contentBlocks = [];
          let addressOffset = 1;
          let hiddenMatchesFound = 0;
          doc
            .render()
            .then((htmlElements) => {
              import(
                /* webpackChunkName: "pdfmake" */ 'pdfmake/build/pdfmake'
              ).then(() => {
                // After converting the RTF to HTML nodes, process them
                // into objects that the PDFMake library can process.
                let prependNewLineToNextElement = false;
                htmlElements.forEach((element, elementKey) => {
                  const hiddenMatchFound =
                    element.text().trim().startsWith('#') &&
                    element.text().trim().endsWith('#');
                  if (hiddenMatchFound) {
                    hiddenMatchesFound++;
                    if (hiddenMatchesFound >= 2) {
                      addressOffset++;
                    }
                  }

                  let elements = [];
                  const childNodes = element.children();

                  if (childNodes.length) {
                    childNodes.each((key, childElement) => {
                      // The first line with the date needs extra spacing.
                      const isDate =
                        moment(
                          $(childElement).text().trim(),
                          'D MMMM YYYY',
                          true
                        ).isValid() && childNodes.length <= 1;

                      let table = null;
                      let tableLayout = null;
                      if (
                        $(childElement).prop('tagName').toLowerCase() ==
                          'table' &&
                        $(childElement).text().includes('Particulars')
                      ) {
                        table = {
                          headerRows: 1,
                          widths: ['30%', '30%', '40%'],
                          body: [],
                        };

                        $(childElement)
                          .children()
                          .each((key, tr) => {
                            let tableRow = [];
                            $(tr)
                              .children()
                              .each((key, td) => {
                                tableRow.push($(td).children().first().text());
                              });
                            table.body.push(tableRow);
                          });
                      } else if (
                        $(childElement).prop('tagName').toLowerCase() ==
                          'table' &&
                        $(childElement).text().includes('Damages')
                      ) {
                        table = {
                          headerRows: 0,
                          widths: ['50%', '50%'],
                          body: [],
                        };

                        let tableRow1 = [];
                        tableRow1.push(
                          $(
                            $(
                              $($(childElement).children()[0]).children()[0]
                            ).children()[0]
                          ).text()
                        );
                        tableRow1.push(
                          $(
                            $(
                              $($(childElement).children()[0]).children()[1]
                            ).children()[0]
                          ).text()
                        );

                        let tableRow2 = [];
                        tableRow2.push(
                          $(
                            $(
                              $($(childElement).children()[0]).children()[0]
                            ).children()[1]
                          ).text()
                        );
                        tableRow2.push(
                          $(
                            $(
                              $($(childElement).children()[0]).children()[1]
                            ).children()[1]
                          ).text()
                        );

                        table.body.push(tableRow1);
                        table.body.push(tableRow2);
                      } else if (
                        $(childElement).prop('tagName').toLowerCase() ==
                          'table' &&
                        $(childElement).text().includes('Overdue')
                      ) {
                        // 'Overdue' table.
                        tableLayout = 'noBorders';
                        const rows = childElement.getElementsByTagName('tr');
                        if (rows && rows.length > 0) {
                          // Assumes there is always two columns, but supports
                          // any number of rows.
                          table = {
                            headerRows: 0,
                            widths: ['50%', '50%'],
                            body: [],
                          };

                          for (let row of rows) {
                            let tableRow = [];
                            const tableRowCells =
                              row.getElementsByTagName('td');
                            if (tableRowCells && tableRowCells.length > 0) {
                              let cellIndex = 0;
                              for (let cell of tableRowCells) {
                                const spans = cell.getElementsByTagName('span');
                                if (spans && spans.length > 1) {
                                  // Some table cells have multiple spans, with
                                  // each needing to be placed on a new line.
                                  let cellText = '';
                                  for (let span of spans) {
                                    cellText += '\n' + $(span).text();
                                  }
                                  tableRow.push({
                                    text: cellText.replace('\n', ''),
                                    style: cellIndex > 0 ? 'right' : '',
                                  });
                                } else {
                                  // If there is not multiple spans, just
                                  // extract the text from the cell and apply
                                  // required styling.
                                  if (
                                    $(cell).children().css('font-weight') ==
                                    'bold'
                                  ) {
                                    tableRow.push({
                                      text: $(cell).text(),
                                      style:
                                        cellIndex > 0 ? 'boldRight' : 'bold',
                                    });
                                  } else {
                                    tableRow.push({
                                      text: $(cell).text(),
                                      style: cellIndex > 0 ? 'right' : '',
                                    });
                                  }
                                }
                                cellIndex++;
                              }
                            }
                            table.body.push(tableRow);
                          }
                        }
                      }

                      // Apply styles depending on extracted fontWeight or
                      // fontFamily or textContent.
                      let style;
                      if ($(childElement).css('font-weight') == 'bold') {
                        style = 'bold';
                      } else if (
                        $(childElement)
                          .css('font-family')
                          .includes('Freestyle Script')
                      ) {
                        style = 'script';
                      } else if (
                        $(element).text().toLowerCase().includes('reference:')
                      ) {
                        style = 'right';
                      }

                      let textContent = $(childElement).text();

                      // Determine if we need to add a new line character.
                      // The last child node of an element should have a new line
                      // Except for elements which are part of the address
                      let appendNewLine =
                        Object.is(childNodes.length - 1, key) &&
                        elementKey !== addressOffset + 1 &&
                        elementKey !== addressOffset + 2 &&
                        elementKey !== addressOffset + 3;

                      // Don't put a new line between customer reference and payment reference
                      if (
                        element
                          .text()
                          .toLowerCase()
                          .includes('customer reference') &&
                        $(htmlElements[elementKey + 1])
                          .text()
                          .toLowerCase()
                          .includes('payment reference')
                      ) {
                        appendNewLine = false;
                      }

                      if (appendNewLine) {
                        textContent += '\n\n';
                      }
                      if (prependNewLineToNextElement) {
                        // If the previous element was a table we need to prepend a newline
                        textContent = '\n' + textContent;
                        prependNewLineToNextElement = false;
                      }

                      // Replace duplicate spaces
                      textContent = textContent.replace(/  +/g, ' ');

                      // Replace placeholder strings with actual endash/emdash (–/—)
                      textContent = textContent
                        .replace(/__endash__/g, '–')
                        .replace(/__emdash__/g, '—');

                      // Replace middot with bullet
                      textContent = textContent.replace(/·/g, '•');

                      // Add additional spacing below date
                      if (isDate) {
                        textContent += '\n\n';
                      }

                      // Adjust spacing around signature
                      if (style == 'script') {
                        textContent = textContent.trimEnd();
                      }

                      if (table) {
                        elements.push({ table: table, layout: tableLayout });
                        prependNewLineToNextElement = true;
                      } else {
                        elements.push({
                          text: hiddenMatchFound ? '' : textContent,
                          style: style,
                        });
                      }
                    });
                  } else {
                    elements.push({ text: '\n' });
                  }
                  if (elements[0]['table']) {
                    contentBlocks.push(elements[0]);
                    // Some table elements have an extra text element.
                    if (elements[1]) {
                      contentBlocks.push({ text: elements });
                    }
                  } else {
                    contentBlocks.push({ text: elements });
                  }
                });
                const nodes = contentBlocks.map((x) => {
                  if (x['table']) {
                    return x;
                  } else {
                    return { text: x };
                  }
                });

                // Letterhead (same as transactions table letterhead.)
                const letterHead = {
                  layout: 'noBorders',
                  table: {
                    widths: ['60%', '*'],
                    body: [
                      [
                        { image: Logo, width: 180 },
                        { image: LetterHead, width: 200 },
                      ],
                    ],
                  },
                  style: 'letterHead',
                };

                // PDF styles.
                const docDefinition = {
                  content: [letterHead, ...nodes],
                  styles: {
                    bold: {
                      bold: true,
                    },
                    script: {
                      font: 'AlexBrush',
                      fontSize: 30,
                    },
                    right: {
                      alignment: 'right',
                    },
                    boldRight: {
                      bold: true,
                      alignment: 'right',
                    },
                    letterHead: {
                      margin: [0, 0, 0, 32],
                    },
                  },
                  defaultStyle: {
                    fontSize: 11,
                    lineHeight: 1.2,
                  },
                };

                // PDF fonts
                const fontHost =
                  location.protocol + '//' + location.hostname + '/';
                pdfMake.fonts = {
                  AlexBrush: {
                    normal:
                      fontHost +
                      'resources/themes/myhnz/fonts/pdf/AlexBrush-Regular.ttf',
                  },
                  Roboto: {
                    normal:
                      fontHost +
                      'resources/themes/myhnz/fonts/pdf/Roboto-Regular.ttf',
                    bold:
                      fontHost +
                      'resources/themes/myhnz/fonts/pdf/Roboto-Bold.ttf',
                  },
                };

                // Create and download the PDF.
                const pdf = pdfMake.createPdf(docDefinition);
                const browser = Bowser.getParser(window.navigator.userAgent);
                const browserName = browser.getBrowserName();

                // Edge and IE don't support the 'open' method so we
                // need to download the PDF in those cases.
                if (
                  window.navigator.userAgent.includes('Android') ||
                  browserName == 'Internet Explorer' ||
                  browserName == 'Microsoft Edge' ||
                  browserName == 'Samsung Internet for Android' ||
                  browserName == 'Safari'
                ) {
                  pdf.download(id.toString() + '.pdf');
                } else {
                  pdf.open();
                }
              });
            })
            .catch((error) => {
              console.error(error);
              // If there is an error it's most likely due to faulty
              // RTFJS table parsing.
              // So try parse the RTF with the stable RTFJS (which does not
              // have table support) and instead manually construct any tables.
              // @TODO Only use the stable RTFJS release and manually construct
              // tables as the table support is flaky and still requires some
              // manual construction. Also remove reliance on magic strings.
              import(/* webpackChunkName: "RTFJS2" */ 'rtf.js2').then(
                (module2) => {
                  const RTFJS2 = module2.RTFJS;

                  let rtf = response.data.letter;

                  // This is trick to make endash & emdash characters (– & —) render in the PDF
                  // __endash__ & __emdash__ are placeholder strings that will later be replaced by an actual endash/emdash character
                  rtf = rtf
                    .replace(/\\endash/g, '__endash__')
                    .replace(/\\emdash/g, '__emdash__');

                  const buffer = new ArrayBuffer(rtf.length);
                  const bufferView = new Uint8Array(buffer);
                  for (let i = 0; i < rtf.length; i++) {
                    bufferView[i] = rtf.charCodeAt(i);
                  }
                  const doc = new RTFJS2.Document(buffer);

                  let contentBlocks = [];
                  doc.render().then((htmlElements) => {
                    import(
                      /* webpackChunkName: "pdfmake" */ 'pdfmake/build/pdfmake'
                    ).then(() => {
                      // After converting the RTF to HTML nodes, process them
                      // into objects that the PDFMake library can process.
                      let prependNewLineToNextElement = false;
                      htmlElements.forEach((element, elementKey) => {
                        const hiddenMatchFound =
                          $(element).text().trim().startsWith('#') &&
                          $(element).text().trim().endsWith('#');

                        let elements = [];
                        const childNodes = $(element).children();

                        if (childNodes.length) {
                          // Figure out if these nodes are a 'table'.
                          // A table currently is
                          // 1. All children are divs
                          // 2. There are more than two child nodes
                          // 3. There is at least one currency only text value.
                          let table = null;
                          let allDivs = true;
                          for (const childNode of childNodes) {
                            if (childNode.tagName !== 'DIV') {
                              allDivs = false;
                            }
                          }
                          let numberOfCurrencyCells = 0;
                          childNodes.each((key, child) => {
                            const currencyRegex =
                              /^\$[+-]?[0-9]{1,3}(?:,?[0-9]{3})*(?:\.[0-9]{2})?$/;
                            if (
                              currencyRegex.test(
                                $(childNodes[key]).text().trim()
                              )
                            ) {
                              numberOfCurrencyCells++;
                            }
                          });

                          if (
                            allDivs &&
                            childNodes.length > 2 &&
                            numberOfCurrencyCells >= 1
                          ) {
                            // Generate table.
                            table = {
                              headerRows: 0,
                              widths: ['50%', '50%'],
                              body: [],
                            };
                            if (numberOfCurrencyCells <= 2) {
                              const tableRow = [];
                              tableRow.push({ text: $(childNodes[0]).text() });
                              tableRow.push({
                                text: $(childNodes[1]).text(),
                                style: 'right',
                              });
                              table.body.push(tableRow);
                            } else if (numberOfCurrencyCells >= 3) {
                              const tableRow = [];
                              tableRow.push({
                                text:
                                  $(childNodes[0]).text() +
                                  '\n' +
                                  $(childNodes[1]).text(),
                              });
                              tableRow.push({
                                text:
                                  $(childNodes[3]).text() +
                                  '\n' +
                                  $(childNodes[4]).text(),
                                style: 'right',
                              });
                              table.body.push(tableRow);

                              // Total row
                              table.body.push([
                                {
                                  text: $(childNodes[2]).text(),
                                  style: 'bold',
                                },
                                {
                                  text: $(childNodes[5]).text(),
                                  style: 'boldRight',
                                },
                              ]);
                            }
                            elements.push({
                              table: table,
                              layout: 'noBorders',
                            });

                            const childNodeOffset = 2 * numberOfCurrencyCells;
                            // Add a new line if the first element that is not
                            // part of the table is not an empty string.
                            if (
                              $(childNodes[childNodeOffset]).text().trim() !==
                              ''
                            ) {
                              elements.push({
                                text: '\n',
                              });
                            }
                            // Process elements that do not make up the table.
                            for (
                              let i = childNodeOffset;
                              i < childNodes.length;
                              i++
                            ) {
                              const text = $(childNodes[i]).text().trim();
                              const fontWeight = $(childNodes[i])
                                .children()
                                .first()
                                .css('font-weight');
                              elements.push({
                                text: text !== '' ? text : '\n',
                                style: fontWeight == 'bold' ? 'bold' : '',
                              });
                            }
                          } else {
                            childNodes.each((key, childElement) => {
                              let elementToProcess = childElement;
                              const childElements =
                                $(elementToProcess).children();
                              if (elementToProcess.nodeName === 'DIV') {
                                // Most elements are spans, but in rare cases
                                // the spans are contained in the div.
                                if (childElements.length) {
                                  elementToProcess =
                                    $(elementToProcess).children()[0];

                                  // Sigature is the second last HTML element.
                                  // Add an additional new line to it.
                                  if (
                                    key === 0 &&
                                    elementKey === htmlElements.length - 2
                                  ) {
                                    $(elementToProcess).append('\n');
                                  }
                                }
                                $(elementToProcess).append('\n');
                              }

                              // Apply styles depending on extracted fontWeight or
                              // fontFamily or textContent.
                              let style;
                              if (
                                $(elementToProcess).css('font-weight') == 'bold'
                              ) {
                                style = 'bold';
                              } else if (
                                $(elementToProcess)
                                  .css('font-family')
                                  .includes('Freestyle Script')
                              ) {
                                style = 'script';
                              } else if (
                                $(element)
                                  .text()
                                  .toLowerCase()
                                  .includes('reference:')
                              ) {
                                style = 'right';
                              }

                              if (childElements.length == 2) {
                                table = {
                                  headerRows: 0,
                                  widths: ['50%', '50%'],
                                  body: [
                                    [
                                      { text: $(childElements[0]).text() },
                                      {
                                        text: $(childElements[1]).text(),
                                        style: 'right',
                                      },
                                    ],
                                  ],
                                };
                              }

                              let textContent = $(elementToProcess).text();

                              // Add new line to 'subject' line.
                              if (
                                textContent.includes(
                                  'Thank you for setting up an arrangement'
                                )
                              ) {
                                textContent = '\n' + textContent;
                              }

                              // Determine if we need to add a new line character.
                              // The last child node of an element should have a new line
                              // Except for elements which are part of the address
                              let appendNewLine = false;

                              // Don't put a new line between customer reference and payment reference
                              if (
                                $(element)
                                  .text()
                                  .toLowerCase()
                                  .includes('customer reference') &&
                                $(htmlElements[elementKey + 1])
                                  .text()
                                  .toLowerCase()
                                  .includes('payment reference')
                              ) {
                                appendNewLine = false;
                              }

                              if (appendNewLine) {
                                textContent += '\n\n';
                              }
                              if (prependNewLineToNextElement) {
                                // If the previous element was a table we need to prepend a newline
                                textContent = '\n' + textContent;
                                prependNewLineToNextElement = false;
                              }

                              // Replace placeholder strings with actual endash/emdash (–/—)
                              textContent = textContent
                                .replace(/__endash__/g, '–')
                                .replace(/__emdash__/g, '—');

                              // Replace middot with bullet
                              textContent = textContent.replace(/·/g, '•');

                              // Adjust spacing around signature
                              if (style == 'script') {
                                textContent = textContent.trimEnd();
                              }
                              if (table) {
                                elements.push({
                                  table: table,
                                  layout: 'noBorders',
                                });
                              } else {
                                elements.push({
                                  text: hiddenMatchFound ? '' : textContent,
                                  style: style,
                                });
                              }
                            });
                          }
                        } else {
                          // Empty elements should be a new line, except for
                          // some early elements as these cause too much
                          // spacing between the date and address.
                          elements.push({
                            text:
                              elementKey !== 2 && elementKey !== 3 ? '\n' : '',
                          });
                        }
                        if (elements[0]['table']) {
                          contentBlocks.push(elements[0]);
                          // Some table elements have extra text elements.
                          if (elements[1]) {
                            for (let i = 1; i < elements.length; i++) {
                              contentBlocks.push(elements[i]);
                            }
                          }
                        } else {
                          contentBlocks.push({ text: elements });
                        }
                      });
                      const nodes = contentBlocks.map((x) => {
                        if (x['table']) {
                          return x;
                        } else {
                          return { text: x };
                        }
                      });

                      // Letterhead (same as transactions table letterhead.)
                      const letterHead = {
                        layout: 'noBorders',
                        table: {
                          widths: ['60%', '*'],
                          body: [
                            [
                              { image: Logo, width: 180 },
                              { image: LetterHead, width: 200 },
                            ],
                          ],
                        },
                        style: 'letterHead',
                      };

                      // PDF styles.
                      const docDefinition = {
                        content: [letterHead, ...nodes],
                        styles: {
                          bold: {
                            bold: true,
                          },
                          script: {
                            font: 'AlexBrush',
                            fontSize: 30,
                          },
                          right: {
                            alignment: 'right',
                          },
                          boldRight: {
                            bold: true,
                            alignment: 'right',
                          },
                          letterHead: {
                            margin: [0, 0, 0, 32],
                          },
                        },
                        defaultStyle: {
                          fontSize: 11,
                          lineHeight: 1.2,
                        },
                      };

                      // PDF fonts
                      const fontHost =
                        location.protocol + '//' + location.hostname + '/';
                      pdfMake.fonts = {
                        AlexBrush: {
                          normal:
                            fontHost +
                            'resources/themes/myhnz/fonts/pdf/AlexBrush-Regular.ttf',
                        },
                        Roboto: {
                          normal:
                            fontHost +
                            'resources/themes/myhnz/fonts/pdf/Roboto-Regular.ttf',
                          bold:
                            fontHost +
                            'resources/themes/myhnz/fonts/pdf/Roboto-Bold.ttf',
                        },
                      };

                      // Create and download the PDF.
                      const pdf = pdfMake.createPdf(docDefinition);
                      const browser = Bowser.getParser(
                        window.navigator.userAgent
                      );
                      const browserName = browser.getBrowserName();

                      // Edge and IE don't support the 'open' method so we
                      // need to download the PDF in those cases.
                      if (
                        browserName == 'Internet Explorer' ||
                        browserName == 'Microsoft Edge' ||
                        browserName == 'Samsung Internet for Android' ||
                        browserName == 'Safari'
                      ) {
                        pdf.download(id.toString() + '.pdf');
                      } else {
                        pdf.open();
                      }
                    });
                  });
                }
              );
            })
            .finally(() => {
              this.setState({
                loadingLetter: false,
              });

              this.setViewedLetter(id);
            });
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({
          loadingLetter: false,
        });
      });
  }

  setViewedLetter(letterId) {
    const { setViewedLetter } = this.props;

    // Remove milliseconds from datetime string
    const currentDateTime = moment().toISOString(true).split('.')[0];

    const viewIndicatorId = letterId;

    const data = {
      id: viewIndicatorId,
      type: 'letters',
      version: '1',
      action: 'viewed',
      date: currentDateTime,
    };

    preferencesApi.createOrUpdateViewIndicator(data);

    setViewedLetter(letterId);
  }

  isLetterViewed(letterId) {
    const { preferences } = this.props;

    const viewed =
      (preferences.data.viewIndicators &&
        preferences.data.viewIndicators.some((vi) => vi.id == letterId)) ||
      preferences.viewedLetters.includes(letterId);

    return viewed;
  }

  render() {
    const {
      toggleContactModal,
      getLetters,
      signout,
      inOutage,
      outageFrom,
      outageTo,
      outageMessage,
      letters,
      goDash,
      preferences,
    } = this.props;

    const { loadingLetter } = this.state;

    const help = portalGuidances.find(
      (guidance) => guidance.Title === stringsComponent
    ) && (
      <HelpCard
        title={getString('help', 'TITLE')}
        subheading={getString('help', 'SUBHEADING')}
        content={
          portalGuidances.find(
            (guidance) => guidance.Title === stringsComponent
          ).Content
        }
        contact={
          portalGuidances.find(
            (guidance) => guidance.Title === stringsComponent
          ).Contact
        }
        faqs={
          portalGuidances.find(
            (guidance) => guidance.Title === stringsComponent
          ).FAQs
        }
        icon={<InfoIcon />}
        toggleContactModal={toggleContactModal}
        gaEvent={analyticsApi.event}
      />
    );

    const lettersData = letters.data.letters;

    const messageCard = (
      <MessageCard
        title={portalContent.LETTERS_MESSAGE_TITLE}
        icon={<LettersIcon />}
        type="message"
        body={
          <ReplaceContact
            content={portalContent.LETTERS_MESSAGE_BODY}
            action={toggleContactModal}
            isLink={true}
          />
        }
      />
    );

    let letterTableData = [];
    if (lettersData) {
      letterTableData = lettersData.map((letter, index) => {
        const button = (
          <DownloadLink
            label={`${getString(stringsComponent, 'VIEW_LETTER_LABEL')} [PDF]`}
            action={() => {
              this.downloadLetter(letter.letterId);
            }}
            key={index}
          />
        );
        const viewed = this.isLetterViewed(letter.letterId);
        return {
          date: stringToDateShortLeadingZero(letter.date),
          title: letter.title,
          viewLink: button,
          viewed: viewed,
        };
      });
    }

    const table = <LettersTable data={letterTableData} />;

    const WrappedLettersLayout = withLoader(LettersLayout);

    const noLettersCard = (
      <MessageCardSimple>
        <ReplaceContact
          content={getString(stringsComponent, 'NO_LETTERS_HELP')}
          action={toggleContactModal}
          isLink={true}
        />
      </MessageCardSimple>
    );

    return (
      <React.Fragment>
        <LoaderProgress show={loadingLetter} />
        <WrappedLettersLayout
          messageCard={lettersData ? messageCard : null}
          help={help}
          table={lettersData ? table : null}
          noLettersCard={lettersData ? null : noLettersCard}
          loaded={this.getLoadedStatuses()}
          onRefresh={getLetters}
          onError={signout}
          inOutage={inOutage}
          outageFrom={outageFrom}
          outageTo={outageTo}
          outageMessage={
            outageMessage && (
              <ReplaceContact
                content={outageMessage}
                action={toggleContactModal}
                isLink={true}
              />
            )
          }
          failureText={
            <ReplaceContact
              content={portalContent.APP_ERROR_MESSAGE}
              action={toggleContactModal}
              isLink={true}
            />
          }
          notFoundText={portalContent.APP_NOT_FOUND_MESSAGE}
          backAction={goDash}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  tenancy: state.customer.tenancy,
  letters: state.customer.letters,
  inOutage: state.app.inOutage,
  outageFrom: state.app.outageFrom,
  outageTo: state.app.outageTo,
  outageMessage: state.app.outageMessage,
  preferences: state.customer.preferences,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...routingActions,
      ...appActions,
      ...authActions,
      ...customerActions,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Letters);
